import axios from "axios";
import TraderRatesBulkRequestDTO from "@/models/request/TraderRatesBulkRequestDTO";
import TraderRatesBulkReportDTO from "@/models/TraderRatesBulkReportDTO";
import TraderRatesBulkApplyResultDTO from "@/models/TraderRatesBulkApplyResultDTO";
import TraderRatesBulkConflictDTO from "@/models/TraderRatesBulkConflictDTO";

export type TraderRatesBulkApplyResponse =
    | { result: TraderRatesBulkApplyResultDTO, conflict: null }
    | { result: null, conflict: TraderRatesBulkConflictDTO }

export const traderRatesBulk = {
    preview: async (data: TraderRatesBulkRequestDTO): Promise<TraderRatesBulkReportDTO> => {
        let resp = await axios({
            url: `/traffic-groups/rates-management/preview`,
            data,
            method: 'POST',
        });

        return resp.data as TraderRatesBulkReportDTO
    },
    apply: async (data: TraderRatesBulkRequestDTO, previewHash: string): Promise<TraderRatesBulkApplyResponse> => {
        try {
            let resp = await axios({
                url: `/traffic-groups/rates-management/apply`,
                data: {...data, previewHash},
                method: 'PUT',
            });

            return {result: resp.data as TraderRatesBulkApplyResultDTO, conflict: null}
        } catch (error: any) {
            if (error?.response?.status === 409) {
                return {result: null, conflict: error.response.data as TraderRatesBulkConflictDTO}
            }

            throw error
        }
    },
}
